export const CUSTOMER_LIST_ACTION = "CUSTOMER_LIST_ACTION";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_EXPORT_ACTION = "CUSTOMER_EXPORT_ACTION";
export const CUSTOMER_EXPORT_SUCCESS = "CUSTOMER_EXPORT_SUCCESS";
export const CUSTOMER_GET_ITEM_ACTION = "CUSTOMER_GET_ITEM_ACTION";
export const CUSTOMER_GET_ITEM_SUCCESS = "CUSTOMER_GET_ITEM_SUCCESS";
export const CUSTOMER_UPDATE_ACTION = "CUSTOMER_UPDATE_ACTION";
export const CUSTOMER_UPDATE_SUCCESS = "CUSTOMER_UPDATE_SUCCESS";
export const CUSTOMER_FILTER_GET_ALL_ACTION = "CUSTOMER_FILTER_GET_ALL_ACTION";
export const CUSTOMER_FILTER_GET_ALL_SUCCESS = "CUSTOMER_FILTER_GET_ALL_SUCCESS";